import { render, staticRenderFns } from "./asset-bars.vue?vue&type=template&id=fcc0c2e4&"
import script from "./asset-bars.vue?vue&type=script&lang=js&"
export * from "./asset-bars.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports